import { useMemo } from "react";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";

const Cache = (isRTL: boolean) => {
  const cache = useMemo(() => {
    if (isRTL) {
      return createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin],
      });
    } else {
      return createCache({ key: "css" });
    }
  }, [isRTL]);

  return cache;
};

export default Cache;
